import React from "react";

import Paper from "../../../../../componentsv2/Paper";
import { formatarMoedaBrl } from "../../../utils/descontoAgendamento";
import calcularPercentualBarra from "../utils/calcularPercentualBarra";

export default function RankingPacientes({
  titulo,
  subtitulo,
  itens = [],
  tipo = "atendimentos",
}) {
  const maiorValor = itens.reduce((maior, item) => {
    const valor = tipo === "valor" ? item.valorInvestido : item.totalAtendimentos;
    return Math.max(maior, Number(valor || 0));
  }, 0);

  return (
    <Paper style={{ padding: "20px", borderRadius: "12px", height: "100%" }}>
      <h3 style={{ margin: 0, color: "#202638", fontSize: "16px" }}>{titulo}</h3>
      <p style={{ margin: "6px 0 20px", color: "#7C8798", fontSize: "13px" }}>
        {subtitulo}
      </p>

      {!itens.length && (
        <div style={{ color: "#7C8798", fontSize: "14px", padding: "24px 0" }}>
          Nenhum dado encontrado para o período.
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
        {itens.map((item, index) => {
          const valor = tipo === "valor" ? item.valorInvestido : item.totalAtendimentos;
          const percentual = calcularPercentualBarra(valor, maiorValor);
          const labelValor =
            tipo === "valor"
              ? formatarMoedaBrl(valor)
              : `${item.totalAtendimentos} atend.`;

          return (
            <div key={item.clienteId || `${item.nome}-${index}`}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "12px",
                  marginBottom: "8px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "8px", minWidth: 0 }}>
                  <span
                    style={{
                      width: "22px",
                      height: "22px",
                      borderRadius: "50%",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: index === 0 ? "#1F3FA3" : "#E8ECF8",
                      color: index === 0 ? "#FFFFFF" : "#7C8798",
                      fontSize: "12px",
                      fontWeight: 700,
                      flexShrink: 0,
                    }}
                  >
                    {index + 1}
                  </span>
                  <span
                    title={item.nome}
                    style={{
                      color: "#202638",
                      fontSize: "14px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.nome}
                  </span>
                </div>
                <strong style={{ color: "#1F3FA3", fontSize: "13px", flexShrink: 0 }}>
                  {labelValor}
                </strong>
              </div>
              <div
                style={{
                  height: "7px",
                  backgroundColor: "#E5E7EB",
                  borderRadius: "999px",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: `${percentual}%`,
                    height: "100%",
                    backgroundColor: "#1F3FA3",
                    borderRadius: "999px",
                  }}
                />
              </div>
              {tipo === "valor" && (
                <span
                  style={{
                    color: "#7C8798",
                    display: "block",
                    fontSize: "12px",
                    marginTop: "4px",
                    textAlign: "right",
                  }}
                >
                  {item.totalAtendimentos} atendimentos
                </span>
              )}
            </div>
          );
        })}
      </div>
    </Paper>
  );
}
